export default "__VITE_ASSET__78c82482__"